import { request } from './request';

let loginToken;
loginToken = JSON.parse(localStorage.getItem("inventory"))?.token ?? "";
const headers = {
  headers: {
    Authorization: `Bearer ${loginToken}`,
  },
};

//Branch Api Group
export const apiCreateBranch = (data) => request('post', '/branch/createBranch', data, headers);

export const apiEditBranch = (data) => request('post', '/branch/editBranch', data,headers);

export const apiCancelBranch = (data) => request('post', '/branch/cancelBranch', data, headers);

export const apiListBranch = (data) => request('post', '/branch/listBranch', data , headers);

//Branch Api Company

export const apiCreateCompany = (data) => request('post', '/company/createCompany', data, headers);

export const apiEditCompany = (data) => request('post', '/company/editCompany', data, headers);

export const apiCancelCompany = (data) => request('post', '/company/cancelCompany', data,headers);

export const apiListCompany = (data) =>
  request(
    'post',
    '/company/listCompany',
    data,
    headers,
  );

//Godown Api Group

export const apiCreateGodown = (data) => request('post', '/godown/createGodown', data, headers);

export const apiEditGodown = (data) => request('post', '/godown/editGodown', data,headers);

export const apiCancelGodown = (data) => request('post', '/godown/cancelGodown', data,headers);

export const apiListGodown = data => request('post', '/godown/listGodown', data, headers);

//Godown Api Group

export const apiCreateBuyer = (data) => request('post', '/buyer/createBuyer', data, headers);

export const apiEditBuyer = (data) => request('post', '/buyer/editBuyer', data,headers);

export const apiCancelBuyer = (data) => request('post', '/buyer/cancelBuyer', data,headers);

export const apiListBuyer = data => request('post', '/buyer/listBuyer', data, headers);

//Item Api Group

export const apiCreateItem = (data) => request('post', '/item/createItem', data, headers);

export const apiEditItem = (data) => request('post', '/item/editItem', data,headers);

export const apiCancelItem = (data) => request('post', '/item/cancelItem', data,headers);

export const apiListItem = data => request('post', '/item/listItem', data, headers);

//Item Cat Api Group

export const apiCreateItemCat = (data) => request('post', '/itemCategory/createItemCategory', data, headers);

export const apiEditItemCat = (data) => request('post', '/itemCategory/editItemCategory', data,headers);

export const apiCancelItemCat = (data) => request('post', '/itemCategory/cancelItemCategory', data,headers);

export const apiListItemCat = data => request('post', '/itemCategory/listItemCategory', data, headers);

//User Cat Api Group

export const apiCreateUser = (data) => request('post', '/user/createUser', data, headers);

export const apiEditUser = (data) => request('post', '/user/editUser', data,headers);

export const apiCancelUser = (data) => request('post', '/user/cancelUser', data,headers);
export const apiClearDevice = (data) => request('post', '/clearDeviceId', data,headers);

export const apiListUser = (data) => request('post', '/user/listUser', data, headers);

export const apiEditUserProfile = (data) => {
  const token = JSON.parse(localStorage.getItem("inventory") || "{}")?.token ?? loginToken ?? "";
  return request('post', '/user/editUserProfile', data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const apiListUserProfile = (data) => {
  const token = JSON.parse(localStorage.getItem("inventory") || "{}")?.token ?? loginToken ?? "";
  return request('post', '/user/listUserProfile', data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

//Customer Api Group
export const apiCreateCustomer = (data) => request('post', '/customer/createCustomer', data, headers);

export const apiEditCustomer = (data) => request('post', '/customer/editCustomer', data,headers);

export const apiCancelCustomer = (data) => request('post', '/customer/cancelCustomer', data,headers);

export const apiListCustomer = data => request('post', '/customer/listCustomer', data, headers);

//PltCommon API
export const apiListPltCommon = data => request('post', '/pltCommon/listPltCommon', data, headers);

export const apiCreatePltCommon = data => request('post', '/pltCommon/createPltCommon', data, headers);

export const apiEditPltCommon = data => request('post', '/pltCommon/editPltCommon', data, headers);

export const apiDeletePltCommon = data => request('post', '/pltCommon/deletePltCommon', data, headers);

export const apiValidateMposKey = data => request('post', '/company/validateApiKey', data, headers);

// Sync Log API Group
export const apiListSyncLog = data => request('post', '/sync/listSync', data, headers);
export const apiResendSyncLog = data => request('post', '/sync/retrySync', data, headers);